export default "__VITE_PUBLIC_ASSET__60d37510__"